export default [
  // 学员电子钱包明细按校区展示弹窗
  {
    name: 'wallet-campus-popup',
    component: () => import(/* webpackChunkName: "walletCampusPopup" */ './wallet-campus-popup.vue'),
  },
];
